import { createEventHook } from '@vueuse/core';

const membershipSwitchHook = createEventHook<void>();

export function useMembershipSwitch() {
    return {
        emitMembershipSwitch: membershipSwitchHook.trigger,
        onMembershipSwitch: membershipSwitchHook.on
    };
}
